export default {
  tries: 0,
  pokemons: [],
  pending: false,
  onScreen: {
    home: true
  }
};